export default __webpack_public_path__ + "static/media/img_blanket_grey.7efd34d0.jpg";